<template>
  <fieldset>
    <div class="form-wrap">

      <div>
        <label for="code">Code</label>
        <input
          id="code"
          type="text"
          v-model="$parent.discount.code"
          required
        />
      </div>

      <div>
        <label for="description">Description</label>
        <input
          id="description"
          type="text"
          v-model="$parent.discount.description"
          required
        />
      </div>
      <div>
        <label for="value">Value</label>
        <input
          title="value"
          id="value"
          type="number"
          placeholder="0.00"
          min="0"
          step="0.01"
          v-model="$parent.discount.value"
          required
        />
      </div>
      <div>
        <label for="percentage">Is percentage discount?</label>
        <label class="switch">
          <input id="penalty_type" type="checkbox" v-model="$parent.discount.penalty_type">
          <span class="switch__slider"></span>
        </label>
      </div>

      <div>
        <label for="per_person">Is per person discounts?</label>
        <label class="switch">
          <input id="per_person" type="checkbox" v-model="$parent.discount.per_person">
          <span class="switch__slider"></span>
        </label>
      </div>

      <div>
        <label for="tour_id">Tour ID</label>
        <select v-if="$parent.discount.id" v-model="$parent.discount.tour_id">
          <option v-for="tour in tours" :value="tour.id" :key="tour.id">{{ tour.name }}</option>
        </select>
        <!-- <select v-else v-model="$parent.discount.tour_id" multiple style="min-height:100px">
          <option v-for="tour in tours" :value="tour.id" :key="tour.id">{{ tour.name }}</option>
        </select> -->
         <v-select
            v-else
            :options="tours"
            label="name"
            class="m-0"
            id="discount"
            index="id"
            v-model="$parent.discount.tour_id"
            multiple
          />
      </div>

      <div>
        <label for="end-date">Tour departure date</label>
        <input id="end-date" type="date" v-model="$parent.discount.start_date" required>
      </div>

      <div>
        <label for="end-date">Tour end date</label>
        <input id="end-date" type="date" v-model="$parent.discount.end_date" required>
      </div>

      <div>
        <label for="end-date">Valid From Date(From when customer can use)</label>
        <input id="end-date" type="date" v-model="$parent.discount.valid_from_date" required>
      </div>

      <div>
        <label for="end-date">Valid To Date(Upto when customer can use)</label>
        <input id="end-date" type="date" v-model="$parent.discount.valid_to_date" required>
      </div>

      <div>
        <label for="on_base_price">Apply on base price only?</label>
        <label class="switch">
          <input id="on_base_price" type="checkbox" v-model="$parent.discount.on_base_price">
          <span class="switch__slider"></span>
        </label>
      </div>

      <div>
        <label for="is_suppressed">Is suppressed?</label>
        <label class="switch">
          <input id="is_suppressed" type="checkbox" v-model="$parent.discount.is_suppressed">
          <span class="switch__slider"></span>
        </label>
      </div>

      <div>
        <label for="is_manul">Is Manual Discount?</label>
        <label class="switch">
          <input id="is_manul" type="checkbox" v-model="$parent.discount.is_manual">
          <span class="switch__slider"></span>
        </label>
      </div>

    </div>
  </fieldset>
</template>

<script>
import axios from 'axios';
export default {
  name: 'DiscountFields',
  data () {
    return {
      tours: [],
      loading: false
    }
  },
  methods:{
    getTours()
    {
      axios.get(this.$api + 'tours')
      .then((response) => {
        this.tours = response.data.data
        console.log(this.tours)
      });
    },
  },
  mounted(){
    this.getTours()
  },
}
</script>
